import { render, staticRenderFns } from "./NoticeMessage.vue?vue&type=template&id=a7d8af9a&scoped=true&"
import script from "./NoticeMessage.vue?vue&type=script&lang=js&"
export * from "./NoticeMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d8af9a",
  null
  
)

export default component.exports